<template>
    <div>
        <nav-bar />
        <div class="filter-button-group mb-2">
            <toggle-button-group
                :buttons="filterOptions" 
                :activeButton="selectedFilter" 
                :handleClick="handleFilterButtonClick" 
            />
        </div>

        <div>
            <div class="kne-title p-10">
                <h3>{{ $t('Drivers.title') }}</h3>
            </div>

            <div class="df fw">
                <h4 style="padding-left: 20px; margin-top: 1rem">Selected group : {{ selectedGroup && selectedGroup.name ? selectedGroup.name : '-' }}</h4>
                <button id="addOrder" class="btn btn-kne-orange m-l-a" v-if="isAdmin" @click="showAddModal = true">
                    {{$t('Drivers.add_driver_file')}}
                </button>
                <button id="addOrder" class="btn btn-kne-orange" v-if="isAdmin" @click="showValidateDriversModal = true">
                    {{ $t('Drivers.validate_drivers') }}
                </button>
            </div>

            <new-driver-modal v-if="showAddModal" @closeModal="closeModal" />
            <update-driver-file-modal v-if="showUpdateModal" @closeModal="closeModal" class="waf-modal"
            :driverFile="driverFile"></update-driver-file-modal>
            <validate-drivers-modal v-if="showValidateDriversModal" :arrOfDriverFile="sortedFiles" @closeModal="closeModal" />

            <div class="main">
                <div class="list-div bg-darkgrey navbar-inverse side-box-shadow" >
                    <ul class="nav flex-column">
                    <li v-for="item in groups" :key="item.id" class="nav-item" :class="{'current': selectedGroup.name === item.name}">
                        <a class="nav-link navbar-text pull-left d-b"  @click="handleItemClick(item)">{{ item.name }}
                        </a>
                    </li>
                    </ul>
                </div>
                <div class="card-div">
                    <div class="cards-div">
                        <div v-if="driverIds.includes(item.id)" class="wall-file-card card" v-for="(item, index) in selectedDriverFiles" :key="index">
                            <h4 class="kne-title" :disabled="isLoading" @click="navigateToZone(item)">
                                <div class="df">
                                    <div>
                                        {{ item.name }}
                                    </div>
                                </div>
                            </h4>
                            <div class="info-card">
                                <div style="font-weight: 600;">{{$t('Drivers.selected_truckNumber')}} : <span> {{ (item.truck && item.truck.truckNumber) || 'NA' }} </span></div>
                                <div style="font-weight: 600;">Total Orders : <span> {{ item.totalOrders || '0' }} </span></div>
                                <div v-for="avl of item.availabilities">{{avl.type}} : <span> {{ convertTimetoHHMMFormat(avl.duration) }} </span></div>
                                <div v-if="!item.availabilities || item.availabilities.length < 4" v-for="i of 4 - (item.availabilities ? item.availabilities.length : 0)"><span>{{ '-' }}</span></div>
                                <div style="display: flex;" class="icons-div">
                                    <button class="btn-del ml-n" :class="{'fill-green': item.isDriving}">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 929 929">
                                            <path d="M464.5 53.5q184.5 0 315.5 131t131 315.5 -131 315.5 -315.5 131 -315.5 -131 -131 -315.5 131 -315.5 315.5 -131zm0 112q-106.5 0 -192.5 62t-122 161l629 0q-36 -99 -122 -161t-192.5 -62zm-.5 390q24 0 40.5 -16.5t16.5 -39.5q0 -24 -17 -40t-39.5 -16 -39 16 -16.5 40 16.5 40 38.5 16zm-334 -56q0 124 79 216.5t199 112.5q-2 -137 -83 -233t-195 -96zm391 329q120 -20 199 -112.5t79 -216.5q-114 0 -195 96t-83 233z"/>
                                        </svg>
                                    </button>
                                     <span>{{ item.speed ? item.speed + ' km/h' : '' }}</span>
                                    <button class="btn-del" @click="editDriverFile(item)" v-if="isAdmin">
                                        <i class="fa fa-pencil" aria-hidden="true" />
                                    </button>
                                    <button class="btn-del" @click="deleteDriverFile(item.id)" v-if="isAdmin">
                                        <i class="fa fa-trash" aria-hidden="true" />
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import { db } from '../../firebase'
import RegularInput from '../module/basic-components/regularInput'
import HoverToolTip from '../module/basic-components/hoverToolTip.vue'
import SidebarToggleButton from '../module/interface-components/sidebarToggleButton.vue'
import NewDriverModal from '../module/special-components/Modal-templates/NewDriver-modal.vue'
import UpdateDriverFileModal from '../module/special-components/Modal-templates/UpdateDriver-modal.vue'
import DefaultOrderModal from '../module/special-components/Modal-templates/DefaultOrder-modal.vue'
import ToggleButtonGroup from '../module/special-components/Other-components/ToggleButtonGroup.vue'
import ValidateDriversModal from '../module/special-components/Modal-templates/ValidateDrivers-modal.vue'
import Draggable from 'vuedraggable'
import moment from 'moment'
import { isRegularOrder } from '@/inventory/inventorySelectors'

export default {
    name: 'Settings',
    components: {
        RegularInput,
        HoverToolTip,
        SidebarToggleButton,
        NewDriverModal,
        UpdateDriverFileModal,
        ValidateDriversModal,
        DefaultOrderModal,
        ToggleButtonGroup,
        Draggable
    },

    data () {
        return {
            driverFiles: [],
            selectedDriverFiles: [],
            showAddModal: false,
            showUpdateModal: false,
            showDefaultOrderModal: false,
            showValidateDriversModal: false,
            selectedGroup: {},
            list: 'Main',
            isLoading: true,
            groups: [],
            processing: [],
            orders: [],
            driverIds: [],
            bookmarks: [],
            groupIdToSelect: '',
            users: [],
            geotab: {},
            selectedFilter: 'driver',
            filterOptions: [
                { label: this.$t('NavBar.wallfile'), value: 'wallfile', route: '/WallFile' },
                { label: this.$t('NavBar.drivers'), value: 'driver', route: '/Drivers' },
                { label: this.$t('NavBar.clients'), value: 'client', route: '/Clients' }
            ],
            groupsListener: null,
            statusInfoListener: null,
            statusLogsListener: null,
            statusAvailabilityListener: null
        }
    },
    async created () {
        this.getDriverFiles()

        const groupId = this.$route.query.groupId
        if (groupId) {
            this.groupIdToSelect = groupId
        }

        await this.getGroups()
        this.isLoading = false
    },
    async mounted () {
    },
    beforeDestroy () {
        if (this.groupsListener) {
            db.ref('database/groups/transporter').child(this.companyUID).child('drivers').child('group').off('value', this.groupsListener)
        }
        if (this.statusInfoListener) {
            db.ref('database/transporter').child(this.companyUID).child('geotab/statusInfo').off('value', this.statusInfoListener)
        }
        if (this.statusLogsListener) {
            db.ref('database/transporter').child(this.companyUID).child('geotab/statusLogs').off('value', this.statusLogsListener)
        }
        if (this.statusAvailabilityListener) {
            db.ref('database/transporter').child(this.companyUID).child('geotab/statusAvailability').off('value', this.statusAvailabilityListener)
        }
    },
    methods: {
        handleFilterButtonClick (buttonName) {
            this.selectedFilter = buttonName

            const selectedOption = this.filterOptions.find(option => option.value === buttonName)
            if (selectedOption && selectedOption.route) {
                this.$router.push(selectedOption.route)
            }
        },
        async getGroups () {
            this.groupsListener = await db.ref('database/groups/transporter').child(this.companyUID).child('drivers').child('group').on('value', (snapshot) => {
                if (!snapshot.exists()) {
                this.groups = []
                return
                }
                this.groups = Object.entries(snapshot.val()).map(([id, zoneData]) => ({
                    id,
                    ...zoneData
                }))

                // Select the group from URL if available
                if (this.groupIdToSelect && this.groups.length > 0) {
                    const groupToSelect = this.groups.find(g => g.id === this.groupIdToSelect)
                    if (groupToSelect) {
                        this.handleItemClick(groupToSelect)
                    }
                    this.groupIdToSelect = null
                } else {
                    const groupToSelect = this.groups[0] || null
                    this.handleItemClick(groupToSelect)
                }
            })
        },
        handleItemClick (item) {
            this.driverIds = []
            this.selectedDriverFiles = []
            let selectedGroups = this.groups.filter(g => g.id === item.id)
            if (!selectedGroups.length) return
            this.selectedGroup = selectedGroups[0]
            this.$router.push({
                query: { groupId: item.id }
            })

            Object.keys(this.selectedGroup.driverFiles).forEach(key => {
                this.driverIds.push(key)
            })
            this.driverFiles.forEach(client => {
                if (this.driverIds.includes(client.id)) {
                    client.priority = this.selectedGroup.driverFiles[client.id]
                    client.index = this.selectedGroup.driverFiles[client.id]
                } else {
                    client.priority = Number.MAX_VALUE
                    client.index = Number.MAX_VALUE
                }
            })
            this.driverFiles = this.driverFiles.sort((a, b) => a.index - b.index)
            this.selectedDriverFiles = this.driverFiles.filter(df => this.driverIds.includes(df.id))
            this.$forceUpdate()
        },
        async getDriverFiles () {
            db.ref('database/driverfiles/transporter').child(this.companyUID).child('driverfile').once('value', async (snapshot) => {
                const driverFilesData = snapshot.val() || {}
                let index = 10000000
                this.driverFiles = Object.entries(driverFilesData).map(([id, data]) => {
                    index++
                    return {
                        id,
                        ...data,
                        index: data.index || index,
                        priority: data.index || index
                    }
                })
                this.driverFiles = this.sortData(this.driverFiles)
                await this.getDrivers()
                this.getOrders()

                if (this.selectedGroup) {
                    this.handleItemClick(this.selectedGroup)
                }
            })
            .catch(error => {
                confirm('Unable to fetch driver files')
                console.error('Error fetching driver files:', error)
            })
        },
        async getDrivers () {
            this.$bindAsArray('users', db.ref('userInfos').child(this.companyUID), null, () => {
                this.driverFiles.forEach(file => {
                    this.users.forEach(user => {
                        if (user['.key'] === file.drivers[0]) {
                            file.driverName = user.firstName + ' ' + user.lastName
                            if (user.geotabId) {
                                file.geotabId = user.geotabId
                            }
                        }
                    })
                })
                this.getGeotabData()
            })
        },
        getOrders () {
            // Use store deliveries instead of binding
            if (!this.$store.state.deliveriesLoaded) {
                this.$store.dispatch('subscribeToDeliveries')
            }
            this.processOrders()
        },
        processOrders () {
            this.processing = this.$store.state.deliveries.filter(isRegularOrder)
            this.driverFiles.forEach(driverFile => {
                driverFile.totalOrders = 0
                driverFile.orders = []
            })
            this.processing.forEach(order => {
                this.driverFiles.forEach(driverFile => {
                    if (!order.historySync) return

                    const keys = Object.keys(order.historySync)
                    const lastKey = keys[keys.length - 1]
                    const driver = order.historySync[lastKey].chauffeur

                    if (driverFile.drivers.includes(driver)) {
                        if (!driverFile.orders.some(or => or['.key'] === order['.key'])) {
                            driverFile.totalOrders += 1
                            driverFile.orders.push(order)
                        }
                    }
                })
            })
            this.isLoading = false
        },
        getGeotabData () {
            this.getStatusLogs()
            this.getStatusInfo()
            this.getStatusAvailability()
        },
        getStatusLogs () {
            moment.locale('en-GB')
            const today = moment().format('DD-MM-YYYY')
            const startOfWeek = moment().startOf('week').format('DD-MM-YYYY')
            this.statusLogsListener = db.ref('database/transporter').child(this.companyUID).child('geotab/statusLogs')
                .orderByKey().startAt(startOfWeek).endAt(today).on('value', (snapshot) => {
                    if (!snapshot.exists()) return
                    const pastWeekData = snapshot.val()
                    this.driverFiles.forEach(file => {
                        file.on = 0
                        file.off = 0
                        file.driving = 0
                        file.standBy = 0
                        if (!file.geotabId) return
                        Object.entries(pastWeekData).forEach(([key, value]) => {
                            if (!value[file.geotabId]) return
                            file.on += value[file.geotabId].on
                            file.off += value[file.geotabId].off
                            file.driving += value[file.geotabId].driving
                            file.standBy += value[file.geotabId].sb
                            file.currentStatus = value[file.geotabId].currentStatus
                        })
                    })
                    this.$forceUpdate()
            })
        },
        getStatusInfo () {
            this.statusInfoListener = db.ref('database/transporter').child(this.companyUID).child('geotab/statusInfo').on('value', (snapshot) => {
                if (!snapshot.exists()) return
                const data = snapshot.val()
                this.driverFiles.forEach(file => {
                        file.statusInfo = data[file.geotabId]
                        if (file.statusInfo) {
                            file.speed = file.statusInfo.speed
                            file.isDriving = file.statusInfo.isDriving
                        }
                    })
                    this.$forceUpdate()
            })
        },
        getStatusAvailability () {
            this.statusAvailabilityListener = db.ref('database/transporter').child(this.companyUID).child('geotab/statusAvailability').on('value', (snapshot) => {
                if (!snapshot.exists()) return
                const data = snapshot.val()
                this.driverFiles.forEach(file => {
                    const statusAvailability = data[file.geotabId]
                    file.availabilities = []
                    if (statusAvailability) {
                        file.availabilities = statusAvailability.availabilities || []
                    } else {
                        file.availabilities = []
                    }
                })
                this.$forceUpdate()
            })
        },
        convertTimetoHHMMFormat (time) {
            let hours = time.split(':')[0]
            const minutes = time.split(':')[1]
            if (hours.includes('.')) {
                const dotHours = hours.split('.')
                hours = parseInt(dotHours[0]) * 24 + parseInt(dotHours[1])
            }
            return `${hours}:${minutes}`
        },
        deleteDriverFile (driverFile) {
            if (!confirm('Please confirm to delete')) return

            db.ref('database/driverfiles/transporter').child(this.companyUID).child('driverfile').child(driverFile).remove()
                .then(() => {
                    console.log('driverFile deleted')
                    this.closeModal()
                })
                .catch(error => {
                    confirm('Error deleting wall file')
                    console.error('Error deleting driverFile from firebase:', error)
                })
        },
        navigateToZone (driverFile) {
            if (this.isLoading) return
            if (!driverFile || !driverFile.totalOrders) {
                confirm('No orders found for the driver')
                return
            }
            this.$router.push({
                name: 'Zone',
                params: {
                    drivers: driverFile.drivers[0],
                    driverStatus: driverFile.statusInfo
                }
            })
        },
        editDriverFile (file) {
            this.showUpdateModal = true
            this.driverFile = file
        },
        async closeModal () {
            this.showAddModal = false
            this.showUpdateModal = false
            this.showValidateDriversModal = false
            await this.getGroups()
            await this.getDriverFiles()
            this.handleItemClick(this.selectedGroup)
        },
        sortData (arr) {
            return arr.sort((a, b) => {
                const aIndex = a.index || Number.MAX_VALUE
                const bIndex = b.index || Number.MAX_VALUE
                return bIndex - aIndex
            })
        },
        closeDefaultOrderModal () {
            this.showDefaultOrderModal = false
            this.getDriverFiles()
        }
    },
    computed: {
        companyUID () {
            return this.$store.state.authorization.company
        },
        sortedFiles () {
            return this.sortData([...this.driverFiles])
        },
        getSelectedDriverFiles () {
            return this.selectedDriverFiles
        },
        uid () {
            return this.$store.state.user.uid
        },
        isAdmin () {
            return this.$store.state.authorization.role === 'Admin'
        },
        storeDeliveries () {
            return this.$store.state.deliveries
        }
    },
    watch: {
        storeDeliveries: {
            handler () {
                if (this.driverFiles.length > 0) {
                    this.processOrders()
                }
            },
            deep: true
        }
    }
}
</script>

<style scoped>
.card-div {
  flex: 2;
  height: calc(100vh - 170px);
  overflow-y: auto;
  scrollbar-width: thin;
}

.current {
  border-left: 3px solid #f7941e;
}
.nav-link {
  cursor: pointer;
}
.main {
  display: flex;
  width: 100%;
}
.list-div {
  height: calc(100vh - 170px);
  overflow-y: auto;
  padding-top: 20px;
  padding-bottom: 20px;
  scrollbar-width: thin;
  width: 200px;
}

.d-b {
  display: block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.df {
  display: flex;
  flex-wrap:wrap;
}
.cards-div {
    display: flex;
    padding: 20px;
    gap: 13px;
    flex-wrap: wrap;
}
.cards-div {
    display: flex;
    padding: 20px;
    gap: 13px;
    flex-wrap: wrap;
}

.kne-title {
    margin-bottom: 0;
}

.wall-file-card {
    width: 19%;
    min-width: 300px;
}

.info-card {
    padding: 15px;
}

.btn-del {
    color: black;
    background: none;
    border: none !important;
}

.m-l-a {
    margin-left: auto;
}

.btn-del:active, .btn-del:focus {
  outline: none;
  border: none !important;
}

#addOrder {
    margin-right: 15px;
    margin-top: 1rem;
}

.cards-div .kne-title div {
    cursor: pointer;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.df {
    display: flex;
}

.p-10 {
    padding: 10px;
}

.ml-n {
    margin-left: 0;
    padding-left: 0;
}

.fill-green {
    color: green;
    fill: green;
}

.icons-div {
    margin-top: 10px;
}

@media (max-width: 450px) {
    .wall-file-card {
        width: 100%;
    }

    #addOrder {
        margin-left: 20px;
        width: 100%;
    }
    .select {
        width: 100% !important;
        margin-right: 20px;
    }
    .fw {
        flex-wrap: wrap;
    }
}
</style>
